import { Divider as Divider$1 } from '@walmart-web/livingdesign-components';
import React__default from 'react';
import { applyCommonProps } from '../../utility/commonProps.js';

var Divider = function Divider(props) {
  var allProps = applyCommonProps(props, Divider);
  return /*#__PURE__*/React__default.createElement(Divider$1, allProps);
};

export { Divider, Divider as default };
